import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import { EcosystemAPIPrefillingUFOExperience } from '@atlassian/jira-issue-create-analytics/src/services/experiences/index.tsx';
import type {
	IssueTriggerPayload,
	Field,
} from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import { usePrefilledDefaultValues } from '../../use-prefilled-default-values/index.tsx';
import { filterCustomFields } from '../filter-custom-fields.tsx';
import { mergeDefaultValues } from '../merge-default-values.tsx';
import { transformGICPayload } from '../transform-payload.tsx';

export const useIssueCreateModalWithPrefillingForIssueCreateEmbed = (): ((
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	fields?: Record<string, any>,
	callback?: Function,
) => Promise<{
	issueCreatePayload: IssueTriggerPayload | null;
	prefilledCustomFields: Field;
	ecosystemCallback:
		| {
				callbackFunction: Function;
		  }
		| undefined;
}>) => {
	const getDefaultValues = usePrefilledDefaultValues();
	const getPrefilledIssueCreateProps = useCallback(
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		async (fields?: Record<string, any>, callback?: Function) => {
			EcosystemAPIPrefillingUFOExperience.start();
			let fieldList = fields;

			const {
				defaultValues: defaultValuesFromAPI,
				issueType,
				projectId,
				requestType,
			} = await getDefaultValues({ prefilledFieldsData: fieldList, callContextAPI: true });

			fieldList = {
				...fieldList,
				pid: projectId,
				issuetype: issueType,
				requestype: requestType,
			};

			let payload: IssueTriggerPayload | null = null;

			if (!isEmpty(fieldList)) {
				payload = transformGICPayload({ prefilledFields: fieldList }, true);
			}

			if (payload) {
				payload.defaultValues = mergeDefaultValues(defaultValuesFromAPI, payload?.defaultValues);
			}

			const prefilledCustomFields = filterCustomFields({ prefilledFields: fieldList });

			EcosystemAPIPrefillingUFOExperience.success();

			return {
				issueCreatePayload: payload,
				prefilledCustomFields,
				ecosystemCallback: callback ? { callbackFunction: callback } : undefined,
			};
		},
		[getDefaultValues],
	);
	return getPrefilledIssueCreateProps;
};
